import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const VISITOR_ID_KEY = "fbn_visitor_id";

const getVisitorId = (): string => {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
};

export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();
  const lastTracked = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;

    // Only track meaningful pages, deduplicate consecutive same-path visits
    if (path === lastTracked.current) return;
    lastTracked.current = path;

    const visitorId = getVisitorId();

    supabase
      .from("page_views")
      .insert({
        page_path: path,
        visitor_id: visitorId,
        user_id: user?.id ?? null,
      })
      .then(); // fire-and-forget
  }, [location.pathname, user?.id]);
};
